import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "logo-box"
};
const _hoisted_3 = {
  key: 0,
  class: "register-title"
};
const _hoisted_4 = {
  key: 1,
  class: "register-title"
};
const _hoisted_5 = {
  key: 2,
  class: "login-title"
};
const _hoisted_6 = {
  class: "content-box"
};
const _hoisted_7 = {
  class: "login-form",
  style: {
    "padding": "0 2rem",
    "box-sizing": "border-box",
    "margin-bottom": "8rem"
  }
};
const _hoisted_8 = {
  class: "form-item"
};
const _hoisted_9 = {
  key: 0,
  class: "form-item"
};
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = {
  key: 1,
  class: "form-item"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
  class: "btn-box"
};
const _hoisted_14 = {
  key: 3,
  style: {
    "width": "100%"
  }
};
const _hoisted_15 = {
  style: {
    "margin-top": "3rem"
  }
};
const _hoisted_16 = {
  key: 0,
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_17 = {
  style: {
    "font-size": "1.6rem"
  }
};
const _hoisted_18 = {
  key: 0,
  class: "action-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "logo",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.back && $setup.back(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/header/logo.png"
  })]), $setup.popupState == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[19] || (_cache[19] = [_createElementVNode("h1", null, "欢迎注册", -1)]))) : _createCommentVNode("", true), $setup.popupState == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[20] || (_cache[20] = [_createElementVNode("h1", null, "重置密码", -1)]))) : $setup.popupState == 1 || $setup.popupState == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $setup.changeAction(2)),
    class: _normalizeClass(["title-item", $setup.popupState == 2 ? 'active' : ''])
  }, " 密码登录 ", 2), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $setup.changeAction(1)),
    class: _normalizeClass(["title-item", $setup.popupState == 1 ? 'active' : ''])
  }, " 短信登录 ", 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
    class: "form-input",
    type: "tel",
    placeholder: "请输入手机号",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.formData.phone = $event)
  }, null, 512), [[_vModelText, $setup.formData.phone]]), $setup.formData.phone ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.clearPhone && $setup.clearPhone(...args)),
    class: "clear",
    src: "https://www.mimodental.com/assets/imgData/img/login/clear.png"
  })) : _createCommentVNode("", true)]), _cache[21] || (_cache[21] = _createElementVNode("input", {
    type: "text",
    value: "",
    style: {
      "opacity": "0",
      "width": "0",
      "height": "0"
    }
  }, null, -1)), $setup.popupState != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    class: "form-input",
    placeholder: $setup.popupState == 3 ? '请输入新密码' : '请输入密码',
    type: "password",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.formData.password = $event)
  }, null, 8, _hoisted_10), [[_vModelText, $setup.formData.password]])])) : _createCommentVNode("", true), _cache[22] || (_cache[22] = _createElementVNode("input", {
    type: "text",
    value: "",
    style: {
      "opacity": "0",
      "width": "0",
      "height": "0"
    }
  }, null, -1)), $setup.popupState != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
    class: "form-input",
    type: "tel",
    placeholder: "请输入验证码",
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.formData.captcha = $event),
    maxlength: "4"
  }, null, 512), [[_vModelText, $setup.formData.captcha]]), _createElementVNode("button", {
    class: "form-btn",
    style: {
      "width": "125px"
    },
    type: "button",
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.get_code && $setup.get_code(...args)),
    disabled: $setup.clock != 60
  }, _toDisplayString($setup.get_code_text), 9, _hoisted_12)])) : _createCommentVNode("", true), $setup.popupState == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    onClick: _cache[8] || (_cache[8] = $event => $setup.changeAction(3)),
    style: {
      "float": "right",
      "font-size": "2rem",
      "font-family": "siyuan_Regular",
      "font-weight": "400",
      "color": "#41B9B2"
    }
  }, " 忘记密码? ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [$setup.popupState == 0 ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    onClick: _cache[9] || (_cache[9] = (...args) => $setup.register && $setup.register(...args)),
    class: _normalizeClass(["btn", $setup.isAccept ? 'accept' : 'unaccept'])
  }, " 注册 ", 2)) : $setup.popupState == 1 || $setup.popupState == 2 ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    onClick: _cache[10] || (_cache[10] = (...args) => $setup.login && $setup.login(...args)),
    class: _normalizeClass(["btn", $setup.isAccept ? 'accept' : 'unaccept'])
  }, " 登录 ", 2)) : $setup.popupState == 3 ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    onClick: _cache[11] || (_cache[11] = (...args) => $setup.reset && $setup.reset(...args)),
    class: "btn reset-btn"
  }, " 重置密码 ")) : _createCommentVNode("", true), $setup.popupState == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", {
    style: {
      "float": "left",
      "font-size": "2.5rem",
      "font-family": "siyuan_Regular",
      "font-weight": "500",
      "color": "#41B9B2"
    },
    onClick: _cache[12] || (_cache[12] = $event => $setup.changeAction(1))
  }, "登录已有账号"), _createElementVNode("div", {
    style: {
      "float": "right",
      "font-size": "2.5rem",
      "font-family": "siyuan_Regular",
      "font-weight": "500",
      "color": "#41B9B2"
    },
    onClick: _cache[13] || (_cache[13] = $event => $setup.changeAction(0))
  }, "新用户注册账号")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [$setup.popupState != 3 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [!$setup.isAccept ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    style: {
      "margin-right": "1rem",
      "vertical-align": "middle",
      "width": "3rem",
      "height": "3rem"
    },
    onClick: _cache[14] || (_cache[14] = $event => $setup.isAccept = !$setup.isAccept),
    src: "https://www.mimodental.com/assets/imgData/img/login/unaccept.png"
  })) : _createCommentVNode("", true), $setup.isAccept ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    style: {
      "margin-right": "1rem",
      "vertical-align": "middle",
      "width": "3rem",
      "height": "3rem"
    },
    onClick: _cache[15] || (_cache[15] = $event => $setup.isAccept = !$setup.isAccept),
    src: "https://www.mimodental.com/assets/imgData/img/login/accept_s.png"
  })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_17, [_cache[23] || (_cache[23] = _createTextVNode("阅读并同意 ", -1)), _createElementVNode("a", {
    style: {
      "color": "#41B9B2",
      "cursor": "pointer"
    },
    onClick: _cache[16] || (_cache[16] = (...args) => $setup.open && $setup.open(...args))
  }, "《米檬口腔隐私政策》")])])) : _createCommentVNode("", true)])]), $setup.popupState == 0 || $setup.popupState == 1 || $setup.popupState == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[24] || (_cache[24] = _createElementVNode("div", {
    class: "left-line"
  }, null, -1)), $setup.popupState == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "action",
    onClick: _cache[17] || (_cache[17] = $event => $setup.changeAction(2))
  }, " 账号登录 ")) : $setup.popupState == 1 || $setup.popupState == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "action",
    onClick: _cache[18] || (_cache[18] = $event => $setup.changeAction(0))
  }, " 用户注册 ")) : _createCommentVNode("", true), _cache[25] || (_cache[25] = _createElementVNode("div", {
    class: "right-line"
  }, null, -1))])) : _createCommentVNode("", true)])])]);
}